import React from 'react';

const Referentiel = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      {/* Page blanche volontairement — en attente d'instructions */}
    </div>
  );
};

export default Referentiel;

